import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SceneBackgroundModalPage } from './scene-background-modal.page';

const routes: Routes = [
  {
    path: '',
    component: SceneBackgroundModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SceneBackgroundModalPage]
})
export class SceneBackgroundModalPageModule {}
